<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  @use "../../../../assets/css/_mixins.scss" as *;
  button {
    @include reset-button;
    color: $primary-color;
    user-select: none;

    &:hover {
      color: $blue;
    }
  }
</style>

<script>
  export let candidateName;
  export let callback = () => {};
</script>

<button class="candidate-name" on:click={callback}>{candidateName}</button>
